<template>
  <div class="relative">
    <ul class="grid cols-5 gap-2">
      <li v-for="({ id, label }, i) in filter.options" :key="id + i">
        <base-toggle
          v-model="model"
          class="full min-h-24 f-col items-center gap-1 b rounded-sm p-1 px-2 pt-3 between hover:bg-grey-90"
          :class="{
            'b-grey-10': model?.includes?.(id),
            'b-grey-70': !model?.includes?.(id),
          }"
          data-test-id="vf-style-filter"
          :value="id"
        >
          <base-picture
            alt=""
            class="aspect-square"
            height="40"
            :src="`/img/tile-images/${id?.toLowerCase().split(' ').join('-')}.svg`"
            width="40"
          />
          <span class="line-clamp-2 max-w-full text-center text-xs font-secondary uppercase" data-test-id="vf-style-filter-text">
            {{ label }}
          </span>
        </base-toggle>
      </li>
    </ul>
    <div v-if="loading" class="absolute-0 bg-white op-50" />
  </div>
</template>

<script lang="ts" setup>
import type { StyleFilter } from '#types/filters'

defineProps<{
  filter: StyleFilter
  loading?: boolean
}>()

const model = defineModel<string[]>()
</script>
